import { useState } from "react";

export default function ChangePickupModal({ onClose }: { onClose: () => void }) {
  const [address, setAddress] = useState("大理古城北门停车场");
  const [submitted, setSubmitted] = useState(false);
  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center" style={{ background: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)" }}>
      <div className="bg-white rounded-t-3xl w-full" style={{ maxWidth: 480 }}>
        <div className="w-10 h-1 rounded-full bg-gray-200 mx-auto mt-3" />
        <div className="flex items-center justify-between px-5 pt-4 pb-3" style={{ borderBottom: "1px solid #F5F5F5" }}>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full cursor-pointer" style={{ background: "#F4F5F9" }}><i className="ri-close-line" style={{ color: "#374151", fontSize: 18 }} /></button>
          <span className="text-base font-bold text-gray-900">更改取车地址</span>
          <div className="w-8" />
        </div>
        <div className="px-5 py-5">
          {submitted ? (
            <div className="flex flex-col items-center py-6">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-3" style={{ background: "#ECFDF5" }}><i className="ri-map-pin-2-line" style={{ color: "#10B981", fontSize: 32 }} /></div>
              <div className="text-base font-bold text-gray-900 mb-1">取车地址已更新</div>
              <div className="text-xs text-gray-500 text-center">新地址：{address}</div>
              <button onClick={onClose} className="mt-5 px-8 py-2.5 rounded-full text-sm font-semibold text-white cursor-pointer whitespace-nowrap" style={{ background: "#10B981" }}>完成</button>
            </div>
          ) : (
            <>
              <div className="mb-3"><div className="text-xs text-gray-500 mb-1.5">当前取车地址</div><div className="p-3 rounded-xl text-sm text-gray-700 font-medium" style={{ background: "#F8F8F8" }}>大理古城北门停车场</div></div>
              <div className="mb-5">
                <div className="text-xs text-gray-500 mb-1.5">新取车地址</div>
                <input className="w-full rounded-xl px-3 py-2.5 text-sm outline-none" style={{ background: "#F8F8F8", border: "1.5px solid #F0F0F0" }} placeholder="请输入新的取车地址" value={address} onChange={e => setAddress(e.target.value)} />
              </div>
              <div className="p-3 rounded-xl mb-5 flex items-start gap-2" style={{ background: "#FFF7ED" }}>
                <i className="ri-information-line flex-shrink-0 mt-0.5" style={{ color: "#EA580C", fontSize: 13 }} />
                <span className="text-xs" style={{ color: "#92400E" }}>更改取车地址可能影响费用，客服将在审核后确认并通知您</span>
              </div>
              <div className="flex gap-3">
                <button onClick={onClose} className="flex-1 py-3 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap" style={{ background: "#F4F5F9", color: "#6B7280" }}>取消</button>
                <button onClick={() => { if (address.trim()) setSubmitted(true); }} className="flex-1 py-3 rounded-full text-sm font-semibold text-white cursor-pointer whitespace-nowrap" style={{ background: "#10B981" }}>确认更改</button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
